import { FunctionComponent, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Loader } from '../Spinner/Loader';

type SessionLoaderProps = {
  isOnboardingFinished: boolean | undefined;
  children: React.JSX.Element;
};

export const SessionLoader: FunctionComponent<SessionLoaderProps> = ({ isOnboardingFinished, children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (
      !isOnboardingFinished &&
      !location.pathname.includes('onboarding') &&
      !location.pathname.includes('/mercado-pago/callback')
    ) {
      navigate('/onboarding');
    }
  }, [isOnboardingFinished, location, location.pathname, navigate]);

  return isOnboardingFinished === undefined ? (
    <div className="flex h-full w-full flex-1 items-center justify-center">
      <Loader fullHeight />
    </div>
  ) : (
    children
  );
};
